/* eslint-disable no-console */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Box from 'ui-box';
import { Button } from 'antd';
import InputField from './form-helpers/InputField';
import LoadingSpinner from '../common/LoadingSpinner';
import {
  errorNotification,
  clearNotification,
  successNotification,
} from '../../utils/notification-helpers';
import { postForgotPasswordApiCall } from '../../api/index';

function ForgotPasswordForm({ onSubmitBtnText }) {
  const { t } = useTranslation(['common']);

  const LoginSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string()
          .required(t('form.error.required'))
          .email(t('form.error.email')),
      }),
    [t]
  );

  const initialValues = {
    email: '',
  };

  const handleForgotPassword = async (data) => {
    const { email } = data;
    const res = await postForgotPasswordApiCall(email);
    if (!res) {
      clearNotification();
      console.error('Failed to process the forgot password request.');
      errorNotification(t('form.error.failedForgotPassword'), 1.5);
    } else {
      clearNotification();
      successNotification(t('form.success.emailSent'), 1.5);
    }
  };

  return (
    <div style={{ width: '100%', textAlign: 'left' }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={async (values) => {
          const userData = { ...values };
          return new Promise(async (resolve, reject) => {
            try {
              await handleForgotPassword(userData);
              resolve();
            } catch (err) {
              reject();
              console.error(err);
            }
          });
        }}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <InputField
                type="email"
                name="email"
                label={t('form.label.emailAddress')}
                placeholder={t('form.placeholder.emailAddress')}
              />
              <Box paddingTop={15}>
                <Button
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  htmlType="submit"
                  type="primary"
                  size="large"
                  block
                >
                  {onSubmitBtnText}
                </Button>
              </Box>
              {isSubmitting ? (
                <LoadingSpinner position="full" transparent={false} />
              ) : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

ForgotPasswordForm.defaultProps = {
  onSubmitBtnText: 'Submit',
};

const { string } = PropTypes;

ForgotPasswordForm.propTypes = {
  onSubmitBtnText: string,
};

export default ForgotPasswordForm;
